module.exports = __webpack_public_path__ + "static/media/rm_06-30.3aac2c5f.png";